class Cookie {

    static Set(name, value, expiresSec, path, secureFlag, sameSite = 'None') {
        const d = new Date();
        d.setTime(d.getTime() + expiresSec * 1000);
        let cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=' + path + (secureFlag === true ? ';secure' : '') + (sameSite !== '' ? ';samesite=' + sameSite : '') + ';';
        document.cookie = cookie;
    }


    static Get(name) {
        const n = name + '=';
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while(c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if(c.indexOf(n) == 0) {
                return c.substring(n.length, c.length);
            }
        }
        return '';
    }


    static Delete(name, path = null) {
        if(path != null) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=' + path + ';';
        } else {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
        }
    }

}
export { Cookie }
